export default __webpack_public_path__ + "static/media/pink1.f59869dd.jpg";